$shm_agent_app_sessions $shm_hitalama_dragtree
	drag_hold_delay 300
	drag_touch_action \auto
	can_have_children* false
	can_be_child* false
	locked false
	pinned* false
